import React, { FC } from 'react';
import styled from 'styled-components';

const StyledLinkButton = styled.button`
  text-decoration: underline;
`;

export interface LinkButtonProps {
  onChangeHandler: (event: React.FormEvent<HTMLButtonElement>) => void;
}

export const LinkButton: FC<LinkButtonProps> = (props) => {
  const { onChangeHandler } = props;
  return (<StyledLinkButton onClick={(event: React.FormEvent<HTMLButtonElement>) => {
    event.preventDefault();
    onChangeHandler(event);
  }}>
    {props.children}
  </StyledLinkButton>);
};
